import { useState } from "react"
import { Report } from "../../interfaces/intakes.reports"
import { useCreatePDF } from "../../api/useSharePDF"
import { pdf } from "@react-pdf/renderer";
import { DocuPdf } from "../pdf/DocuPdf";
import { SpinnerCustom } from "./SpinnerCustom";
import { useNavigate } from "react-router-dom";
import { PDF_STEPS_IMAGES } from "../pdf/PDF_STEPS_IMAGES";
import { PDF_STEPS_MAINDATA } from "../pdf/PDF_STEPS_MAINDATA";
import { useCharts } from "../../hooks/useCharts";

interface Props {
    report: Report
    closeModal: () => void
}
export const ModalCreatePDF = ({ report, closeModal }: Props) => {

    const { charts, ready, DonutsRenderer } = useCharts(report);
    const [finalReport, setFinalReport] = useState<Report>(report)
    const [isCreatingPDF, setIsCreatingPDF] = useState<boolean>(false)
    const [step, setStep] = useState<number>(1)
    const { mutate, isLoading } = useCreatePDF()
    const navigation = useNavigate()

    const handlePreview = () => {
        localStorage.setItem('pdfData', JSON.stringify(finalReport));
        navigation('/view-live-pdf');
    };

    const sendPDFReport = async () => {
        if (!finalReport || !ready) return;
        
        setIsCreatingPDF(true);
        const blob = await pdf(<DocuPdf allData={finalReport} charts={charts}/>).toBlob();

        const file = new File([blob], finalReport.palletRef + ".pdf", {
            type: "application/pdf",
        });

        mutate({ pdf: file, reportId: finalReport!._id }, {
            onSuccess: () => { closeModal() },
            onSettled: () => setIsCreatingPDF(false),
            onError: () => setIsCreatingPDF(false),
        })
    };

    const isCargando = isCreatingPDF || isLoading;

    return (
        <div className="modal">
            <div className="modal__cardPDF">
                {
                    report && DonutsRenderer
                }

                {
                    step === 1 &&
                    <PDF_STEPS_MAINDATA report={report} setFinalReport={setFinalReport} finalReport={finalReport} />
                }

                {
                    step === 2 &&
                    <PDF_STEPS_IMAGES report={report} setFinalReport={setFinalReport} finalReport={finalReport} handlePreview={handlePreview} />
                }

                <div className="tw-flex tw-gap-4 tw-mt-8 tw-justify-between">
                    <button className="tw-px-4 tw-py-2 tw-flex tw-gap-1 tw-items-center tw-justify-center tw-rounded-full tw-text-red-600 tw-border-2 tw-border-red-700" onClick={closeModal}>Close</button>
                    {
                        step === 2
                            ?
                            <div className="tw-flex tw-gap-3">
                                <button className={`tw-rounded-full tw-text-white  ${isCargando ? "tw-bg-blue-400" : "tw-bg-blue-600"} tw-px-5 tw-py-2 tw-flex tw-gap-2 tw-items-center tw-justify-center sm:tw-min-w-[8rem]`} disabled={isCargando} onClick={() => setStep(step => step - 1)}>Previous</button>
                                <button className={`tw-rounded-full tw-text-white ${isCargando ? "tw-bg-blue-400" : "tw-bg-blue-600"} tw-px-5 tw-py-2 tw-flex tw-gap-2 tw-items-center tw-justify-center sm:tw-min-w-[8rem]`} disabled={isCargando} onClick={sendPDFReport}>Save PDF {isCargando && <SpinnerCustom color="white" />}</button>
                            </div>
                            :
                            <div className="tw-flex tw-gap-3">
                                {
                                    step > 1 &&
                                    <button className={`tw-rounded-full tw-text-white ${isCargando ? "tw-bg-blue-400" : "tw-bg-blue-600"} tw-px-5 tw-py-2 tw-flex tw-gap-2 tw-items-center tw-justify-center sm:tw-min-w-[8rem]`} disabled={isCargando} onClick={() => setStep(step => step - 1)}>Previous</button>
                                }
                                <button className={`tw-rounded-full tw-text-white ${isCargando ? "tw-bg-blue-400" : "tw-bg-blue-600"} tw-px-5 tw-py-2 tw-flex tw-gap-2 tw-items-center tw-justify-center sm:tw-min-w-[8rem]`} disabled={isCargando} onClick={() => setStep(step => step + 1)}>Next</button>
                            </div>
                    }
                </div>
            </div>
        </div >
    )
}

